import React, {Component, Children} from "react";
import PropTypes from "prop-types";
import MainNavigationLinks from "./MainNavigationLinks";

export default class Navbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collapsed: true
        };
    }

    renderChildren = () => {
        return Children.map(this.props.children, (child) =>
            child
        );
    };

    render() {
        let collapseClassName = this.state.collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';

        return (
            <nav className="navbar navbar-expand-lg navbar-dark bg-primary mb-3">
                <span className="navbar-brand">Zeiterfassung</span>
                <button className="navbar-toggler" type="button" aria-label="Toggle navigation" onClick={() => this.setState({collapsed: !this.state.collapsed})}>
                    <span className="navbar-toggler-icon"/>
                </button>

                <div className={collapseClassName}>
                    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                        <MainNavigationLinks/>
                    </ul>
                    {this.renderChildren()}
                    <form className="form-inline my-2 my-lg-0">
                        <input className="form-control mr-sm-2" type="search" placeholder="Suche ..." aria-label="Suche"/>
                        <button className="btn btn-outline-light my-2 my-sm-0" type="submit">Suchen</button>
                    </form>
                </div>
            </nav>
        )
    }
}

Navbar.propTypes = {
    children: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/Navbar.js